import { menuItems } from "@peracto/peracto";
// import { faAward } from "@fortawesome/pro-regular-svg-icons/faAward";

export const menu = {
    ...menuItems,
    // warrantyRegistrations: {
    //     label: "Warranty Registrations",
    //     icon: faAward,
    //     path: "/warranty-registrations",
    //     sortOrder: 75,
    //     roles: ["ROLE_ADMIN"],
    // },
};
